import { render } from "./filter-off.svg?vue&type=template&id=8faef308"
const script = {}
script.render = render

export default script